import React from 'react'
import ENVIRONMENT_CONFIG from './ENVIRONMENT_CONFIG'

const EnvironmentContext = React.createContext(ENVIRONMENT_CONFIG)
export default EnvironmentContext
